import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { resets } from '@ui/css';
import { useMicroInteraction } from '@utils/react';
import { toast, messageIcon, error, success, closeButton, wrapper } from './toast.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { CheckmarkIcon } from '../../icons/checkmark.js';
import { CrossIcon } from '../../icons/cross.js';

function Toast(props) {
  const ref = useRef(null);
  const [deferMount] = useMicroInteraction({
    durationMs: 50,
    isEnabledInitially: true
  });
  const role = props.persistent ? "alertdialog" : props.type === "error" ? "alert" : "status";
  useCancelAutoDismissOnSelection(ref, props.cancelAutoDismiss);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: cx(resets.rootCls, wrapper),
    children: [/*#__PURE__*/jsx("div", {
      className: toast,
      "aria-live": "polite",
      "aria-atomic": true,
      role: role,
      children: !deferMount && /*#__PURE__*/jsxs(Fragment, {
        children: [props.type !== "neutral" && /*#__PURE__*/jsx("span", {
          className: cx(messageIcon, props.type === "error" ? error : success),
          children: props.type === "success" && /*#__PURE__*/jsx(CheckmarkIcon, {
            height: "9"
          })
        }), props.children]
      })
    }), /*#__PURE__*/jsx("button", {
      className: closeButton,
      "aria-label": "Luk notifikation",
      onClick: props.onClick,
      "data-dismiss": true,
      children: /*#__PURE__*/jsx(CrossIcon, {
        height: 12.5
      })
    })]
  });
}
function useCancelAutoDismissOnSelection(ref, cancelAutoDismiss) {
  useEffect(() => {
    const toast = ref.current;
    if (!toast) {
      return;
    }
    const onSelectionChange = () => {
      const selection = window.getSelection();
      if (selection?.containsNode(toast, true)) {
        cancelAutoDismiss();
      }
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => {
      document.removeEventListener("selectionchange", onSelectionChange);
    };
  }, [cancelAutoDismiss, ref]);
}

export { Toast };
//# sourceMappingURL=toast.js.map
